import * as Yup from "yup";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import style from './ViewCardPin.module.scss';
import { ROUTES } from "../../../../../routes";
import { useNavigate } from "react-router-dom";
import { Col, Form, Row } from 'react-bootstrap';
import OTP from '../../../../common/Formik/OTP/OTP';
import Button from "../../../../common/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../../common/Modals/Modal/Modal";
import CommonCardStbl from "../CommonCardStbl/CommonCardStbl";
import SetUpdateCardPin from "../SetUpdateCardPin/SetUpdateCardPin";
import { validationMessage } from "../../../../../Helper/helperfunction";
import { SERVICESTYPE, STATUS_CODE } from "../../../../../utils/constants";
import { displayPinAction, generateOTPAction, } from "../../../../../features/user/userSlice";

const ViewCardPin = ({ show, handleClose, cardId, setUpdate }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [btnupdate, setBtnupdate] = useState(false);
    const signUpData = useSelector((state) => state?.persist?.userInfo?.email);

    const validationSchema = Yup.object({
        otp: Yup.string().required(validationMessage("OTP")),
    });

    const formik = useFormik({
        initialValues: {
            otp: "",
        },
        validationSchema: validationSchema,

        onSubmit: async (values) => {
            const payload = {
                otp: values.otp,
                service: "CARD_PIN",
                username: signUpData,
            };
            try {
                const response = await dispatch(displayPinAction(payload, cardId));
                if (response?.data?.status === STATUS_CODE.successful) {
                }
            } catch (error) {
                console.log("PIN ERROR", error);
            }
        },
    });

    const generateOTP = async (action) => {
        const data = {
            username: signUpData,
            type: SERVICESTYPE.EMAIL,
            service: "CARD_PIN_UPDATE",
        };
        try {
            const response = await dispatch(generateOTPAction(data));
            if (response?.status === 200) {
                if (action === "pin") navigate(ROUTES.VIEW_CARD_PIN);
            }
        } catch (error) {
            console.log("OTP Error:", error);
        }
    };

    useEffect(() => {
        generateOTP("activate")
    }, [])

    return (
        <>

            {/* <section className={style.viewCardPin}>
                <Row>
                    <Col xxl={4} xl={5} lg={5} md={6} sm={6} className="card-Col">
                        <div className={style.cardpinleft}>
                            <CommonCardStbl
                                cardType={location?.state?.selectedCard}
                                cardNumber={`**** **** **** ${cardDetails?.debit?.last_four}`}
                                cardName={`${cardDetails?.debit?.application?.first_name || ""} ${cardDetails?.debit?.application?.last_name || ""}`}
                                cardDate={`${cardDetails?.debit?.expiry_month}/${cardDetails?.debit?.expiry_year}`}
                            />
                        </div>
                    </Col>

                    <Col xxl={4} xl={5} lg={5} md={6} sm={6} className="card-Col">
                    </Col>
                </Row>
            </section> */}
            <Modal
                show={show}
                handleClose={handleClose}
                className={style.viewCardPin}
                title='Set/Update Pin'
            >
                <div className={style.cardpinright}>
                    {
                        btnupdate ? (
                            <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                                <div className={style.cardpinhead}>
                                    <h4>View Pin</h4>
                                    <Button
                                        className={style.btnUpdatepin}
                                        variant="without_bg_border"
                                        type="button"
                                        onClick={() => setBtnupdate(true)}
                                    >
                                        Update PIN ?
                                    </Button>
                                </div>

                                <h6>Enter the 6-digit code sent to your Email.</h6>

                                <OTP
                                    name="otp"
                                    value={formik.values.otp}
                                    formik={formik}
                                    onChange={(value) => formik.setFieldValue("otp", value)}
                                    placeholder="------"
                                />

                                <Button
                                    fluid
                                    className={style.btn_pin}
                                    type="button"
                                    onClick={(e) => {
                                        formik.handleSubmit(e);
                                    }}
                                >
                                    Reveal PIN
                                </Button>

                                <p>For your security, the PIN will be visible for 10 seconds only.</p>
                            </form>
                        ) : (
                            <SetUpdateCardPin cardId={cardId} setUpdate={setUpdate} handleClose={handleClose} />
                        )
                    }
                </div>
            </Modal>
        </>
    );
};

export default ViewCardPin;
